import React from 'react'

import './style.scss'

class Countdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {time: {}, seconds: 30}
    this.timer = 0
    this.markCounter = props.markCounter
    this.startTimer = this.startTimer.bind(this)
    this.countDown = this.countDown.bind(this)
  }

  secondsToTime(secs) {
    let divider_for_minutes = secs % (60 * 60)
    let minutes = Math.floor(divider_for_minutes / 60)

    let divider_for_seconds = divider_for_minutes % 60
    let seconds = Math.ceil(divider_for_seconds)

    return {
      'm': minutes,
      's': (seconds < 10 ? '0' : '') + seconds
    }
  }

  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds)
    this.setState({time: timeLeftVar})
    this.startTimer()
  }

  startTimer() {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000)
    }
  }

  countDown() {
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    })

    if (seconds === 0) {
      clearInterval(this.timer)
    }
  }

  render() {
    let { markCounter } = this.props
    let { time } = this.state

    if (time.s >= 0 && markCounter === 4) {
      return <div className='right-indent correct'>Вы нашли все признаки</div>
    } else if (time.s === '00' && markCounter !== 4) {
      return <div className='right-indent wrong'>Вы не успели</div>
    } else {
      return (
        <div className='countdown'>
          {this.state.time.m}:{this.state.time.s}
        </div>
      )
    }
  }
}

export default Countdown
